import { useContext } from "react";
import AuthContext from "../contexts/AuthTokenContext";

const useAuth = () => useContext(AuthContext);

export default useAuth;
